import AppController from 'controllers/app';
import RoutesController from 'controllers/routes';
import AuthorizationController from 'controllers/authorization';
import ResponseController from 'controllers/response-status';
import PostMessageController from 'controllers/post-message';
import UserController from 'controllers/user';
import HierarchyController from 'controllers/hierarchy';
import MasterDataController from 'controllers/master-data';
import DatesController from 'controllers/dates';
import StorageController from 'controllers/storage';
import ExportController from 'controllers/export';
import UploadsController from 'controllers/uploads';
import WhitelistController from 'controllers/whitelist';
import DashboardController from 'controllers/dashboards';
import DashboardDataController from 'controllers/dashboards-data';

const Controllers = {
  app: AppController,
  routes: RoutesController,
  authorization: AuthorizationController,
  'response-status': ResponseController,
  'post-message': PostMessageController,
  user: UserController,
  hierarchy: HierarchyController,
  'master-data': MasterDataController,
  dates: DatesController,
  storage: StorageController,
  export: ExportController,
  uploads: UploadsController,
  whitelist: WhitelistController,
  dashboards: DashboardController,
  'dashboards-data': DashboardDataController,
};

export default Controllers;
